import { v4 as uuidv4 } from 'uuid';

import { IKnmErknmFormJudgmentSubjectData } from '../interfaces/IKnmErknmFormJudgmentSubjectData';
import { createJudgmentProsecutionTypeSelectOption } from '../../../CorePackage/CatalogsModule/common/createJudgmentProsecutionTypeSelectOption';
import { createJudgmentPunishmentTypeSelectOption } from '../../../CorePackage/CatalogsModule/common/createJudgmentPunishmentTypeSelectOption';
import { createJudgmentPunishmentIndexSelectOption } from '../../../CorePackage/CatalogsModule/common/createJudgmentPunishmentIndexSelectOption';
import { createJudgmentCancellationInfoSelectOption } from '../../../CorePackage/CatalogsModule/common/createJudgmentCancellationInfoSelectOption';
import { IKnmErknmFormJudgmentAgainstInfo } from '../interfaces/IKnmErknmFormJudgmentAgainstInfo';
import { IKnmErknmFormJudgmentActsAndDecisions } from '../interfaces/IKnmErknmFormJudgmentActsAndDecisions';
import { IKnmErknmFormAct } from '../interfaces/IKnmErknmFormAct';
import { IKnmErknmFormResultDecision } from '../interfaces/IKnmErknmFormResultDecision';
import { IKnmJudgmentSubjectData } from '../../../APIPackage/KnmModule/interfaces/IKnmJudgmentSubjectData';

export const convertKnmJudgmentSubjectsDataToFormValues = (
  subjectsData: IKnmJudgmentSubjectData[],
  formActs: IKnmErknmFormAct[] | undefined,
  formDecisions: IKnmErknmFormResultDecision[] | undefined,
): IKnmErknmFormJudgmentSubjectData[] => {
  return subjectsData.map(subjectData => {
    const formSubjectData: IKnmErknmFormJudgmentSubjectData = {
      ...subjectData,
      organizationGuid: subjectData.organizationGuid || undefined,
      isJudgmentAgainstOrganizations: subjectData.judgmentAgainstOrganizations ? true : undefined,
      isJudgmentAgainstOfficialPerson: subjectData.judgmentAgainstOfficialPerson ? true : undefined,
      judgmentAgainstOrganizations: subjectData.judgmentAgainstOrganizations
        ? {
            guid: subjectData.judgmentAgainstOrganizations.guid,
            officialPersonFio: subjectData.judgmentAgainstOrganizations.officialPersonFio,
            officialPersonJobTitle: subjectData.judgmentAgainstOrganizations.officialPersonJobTitle,
            prosecutionType: subjectData.judgmentAgainstOrganizations.prosecutionType
              ? createJudgmentProsecutionTypeSelectOption(subjectData.judgmentAgainstOrganizations.prosecutionType)
              : undefined,
            punishmentType: subjectData.judgmentAgainstOrganizations.punishmentType
              ? createJudgmentPunishmentTypeSelectOption(subjectData.judgmentAgainstOrganizations.punishmentType)
              : undefined,
            amountOfPunishment: subjectData.judgmentAgainstOrganizations.amountOfPunishment || undefined,
            punishmentIndex: subjectData.judgmentAgainstOrganizations.punishmentIndex
              ? createJudgmentPunishmentIndexSelectOption(subjectData.judgmentAgainstOrganizations.punishmentIndex)
              : undefined,
            punishmentNoteLawsuits: subjectData.judgmentAgainstOrganizations.punishmentNoteLawsuits || undefined,
            cancellationInformation: subjectData.judgmentAgainstOrganizations.cancellationInformation
              ? createJudgmentCancellationInfoSelectOption(
                  subjectData.judgmentAgainstOrganizations.cancellationInformation,
                )
              : undefined,
            explanation: subjectData.judgmentAgainstOrganizations.explanation || undefined,
            listId: uuidv4(),
            isNew: false,
          }
        : undefined,
      judgmentAgainstOfficialPerson:
        subjectData.judgmentAgainstOfficialPerson?.map(officialPerson => {
          const formOfficialPerson: IKnmErknmFormJudgmentAgainstInfo = {
            ...officialPerson,
            guid: officialPerson.guid,
            officialPersonFio: officialPerson.officialPersonFio,
            officialPersonJobTitle: officialPerson.officialPersonJobTitle,
            prosecutionType: officialPerson.prosecutionType
              ? createJudgmentProsecutionTypeSelectOption(officialPerson.prosecutionType)
              : undefined,
            punishmentType: officialPerson.punishmentType
              ? createJudgmentPunishmentTypeSelectOption(officialPerson.punishmentType)
              : undefined,
            amountOfPunishment: officialPerson.amountOfPunishment || undefined,
            punishmentIndex: officialPerson.punishmentIndex
              ? createJudgmentPunishmentIndexSelectOption(officialPerson.punishmentIndex)
              : undefined,
            punishmentNoteLawsuits: officialPerson.punishmentNoteLawsuits || undefined,
            cancellationInformation: officialPerson.cancellationInformation
              ? createJudgmentCancellationInfoSelectOption(officialPerson.cancellationInformation)
              : undefined,
            explanation: officialPerson.explanation || undefined,
            listId: uuidv4(),
            isNew: !!officialPerson.isNew,
          };

          return formOfficialPerson;
        }) || undefined,
      cancellationActsAndDecisions:
        subjectData.cancellationActsAndDecisions?.map(cancellation => {
          const cancellationTitle = () => {
            if (cancellation.actGuid) {
              return `Акт №${formActs?.find(x => x.guid === cancellation.actGuid)?.numberAct}`;
            }
            if (cancellation.decisionGuid) {
              return `Решение №${formDecisions?.find(x => x.guid === cancellation.decisionGuid)?.numberDecision}`;
            }

            return undefined;
          };

          const formCancellation: IKnmErknmFormJudgmentActsAndDecisions = {
            ...cancellation,
            actGuid: cancellation.actGuid || undefined,
            decisionGuid: cancellation.decisionGuid || undefined,
            title: cancellationTitle(),
            cancellationInformation: cancellation.cancellationInformation
              ? createJudgmentCancellationInfoSelectOption(cancellation.cancellationInformation)
              : undefined,
            newCancellationInformation: cancellation.newCancellationInformation
              ? createJudgmentCancellationInfoSelectOption(cancellation.newCancellationInformation)
              : undefined,
            explanation: cancellation.explanation || undefined,
            newExplanation: cancellation.newExplanation || undefined,
            listId: uuidv4(),
            isNew: false,
          };

          return formCancellation;
        }) || undefined,
      listId: uuidv4(),
      isNew: false,
    };

    return formSubjectData;
  });
};
